import { useTRPCClientAPI, useTRPCMutation } from '../../../../trpc/trpc';
import type { S4aPitch } from '../outreachTypes';

/** The Spotify for Artists pitch of a release (prompt P8, frame m3). Not stored: one call per open. */
export function useS4aPitch(accountId: number) {
  const trpcClient = useTRPCClientAPI();
  const mutation = useTRPCMutation({
    mutationFn: (catalogItemUuid: string) =>
      trpcClient.outreach.s4a.write.mutate({ accountId, catalogItemUuid }) as Promise<S4aPitch>,
  });
  return {
    write: mutation.mutate,
    pitch: mutation.data,
    isWriting: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
